import React from "react";
import { Button } from "@mui/material";
import { StyledBottomActionBar } from "./styled";

function BottomActionBar({
  actionLabel,
  buttonProps = {},
  buttonStyle = {},
  count,
  countLabel = "Selected",
  disabled = false,
  itemLabel,
  onAction,
  onDisabledAction,
  rounded = true,
  showCount = true,
  topContent = null,
}) {
  const normalizedCount = Number(count || 0);
  const displayItemLabel =
    itemLabel ||
    `${normalizedCount} Item${normalizedCount === 1 ? "" : "s"}`;

  return (
    <StyledBottomActionBar rounded={rounded} showCount={showCount}>
      {topContent ? (
        <div className="bottom-action-extra">{topContent}</div>
      ) : null}
      {showCount ? (
        <div className="bottom-action-count">
          <span>{countLabel}</span>
          <strong>{displayItemLabel}</strong>
        </div>
      ) : null}
      <div className="bottom-action-button-wrap">
        <Button
          variant="contained"
          fullWidth
          disabled={disabled}
          onClick={onAction}
          style={{
            borderRadius: rounded ? "10px" : "0px",
            ...buttonStyle,
          }}
          {...buttonProps}
        >
          {actionLabel}
        </Button>
        {disabled && onDisabledAction ? (
          <button
            aria-label="Fix disabled action"
            className="bottom-action-disabled-hitbox"
            onClick={onDisabledAction}
            type="button"
          />
        ) : null}
      </div>
    </StyledBottomActionBar>
  );
}

export default BottomActionBar;
